import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const SKIP = new Set(["SCRIPT", "STYLE", "NOSCRIPT", "TEXTAREA", "CODE", "INPUT", "SELECT"]);
const PRICE = /^([+-]?)\s?(\d{1,3}(?:\.\d{3})+|\d+),(\d{2})\s?€$/;
const rec = new WeakMap();
const usd = (v) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: v >= 100 ? 0 : 2 }).format(v);
const listeners = new Set();
let cur = localStorage.getItem("cs_currency") || "EUR";
let fx = null;
let observer = null;
let timer = null;

function scan() {
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  for (let n = walker.nextNode(); n; n = walker.nextNode()) {
    const r = rec.get(n);
    if (r && n.nodeValue === r.out) continue;
    const el = n.parentElement;
    if (!el || SKIP.has(el.tagName) || el.closest("[data-no-currency]")) continue;
    const m = n.nodeValue.trim().match(PRICE);
    if (!m) continue;
    const v = parseFloat(`${m[2].replace(/\./g, "")}.${m[3]}`);
    const out = `${n.nodeValue} (≈ ${m[1]}${usd(v * fx.rate)})`;
    rec.set(n, { src: n.nodeValue, out });
    n.nodeValue = out;
  }
}

function restore() {
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  for (let n = walker.nextNode(); n; n = walker.nextNode()) {
    const r = rec.get(n);
    if (r && n.nodeValue === r.out) n.nodeValue = r.src;
    rec.delete(n);
  }
}

export const getCurrency = () => cur;
export const getRate = () => fx;

export const useCurrency = () => {
  const [c, setC] = useState(cur);
  useEffect(() => {
    listeners.add(setC);
    return () => { listeners.delete(setC); };
  }, []);
  return c;
};

export async function setCurrency(next) {
  restore();
  cur = next;
  listeners.forEach((fn) => fn(next));
  localStorage.setItem("cs_currency", next);
  observer?.disconnect();
  observer = null;
  if (next === "EUR") return;
  if (!fx) {
    try {
      fx = (await api.get("/fx/eur-usd")).data;
    } catch {
      return;
    }
  }
  if (cur !== next) return;
  observer = new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(scan, 100); });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  scan();
}
